import styled from 'styled-components'
import { Colors } from 'cio-design-library/design-tokens'
import Media from 'builder/styles/media'
import Typography, { FontWeights } from 'builder/styles/typography'

export const InfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 48px;
  max-width: 448px;
  width: 100%;
  height: 100%;

  ${Media.Tablet`
    max-width: 540px;
  `}
`

export const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 24px;
  width: 100%;

  ${Media.Phone`
    gap: 8px;
  `}
`

export const VideoContainer = styled.div`
  max-width: 544px;
  width: 100%;
  height: 544px;
  background-color: ${Colors.Neutral5};
  border-radius: 16px;
  overflow: hidden;
  position: relative;

  ${Media.Tablet`
    max-width: 540px;
    width: 100%;
    height: 336px;
  `}

  ${Media.Phone`
    height: 260px;
  `}
`

export const Video = styled.video`
  width: 100%;
  height: 100%;
  border-radius: 16px;
  object-fit: cover;
  transform: scale(1.002);
  transform-origin: center;
`

export const VideoInfoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 96px;
  position: absolute;
  bottom: 0;
  margin: 0 4px 4px;
  width: 98.5%;
  z-index: 1;
  border-radius: 12px;
  border: 0.5px solid ${Colors.Neutral15};
  background: ${Colors.White};
`

export const VideoInfo = styled.div`
  ${Typography.Subhead}

  width: 350px;
  text-align: center;
  color: ${Colors.Neutral90};

  ${Media.Phone`
    width: 263px;
  `}

  span {
    ${FontWeights.Medium}
  }
`

export const ActionsContainer = styled.div`
  width: 100%;
  margin-top: auto;
`

export const Image = styled.img`
  width: 448px;
  height: 448px;
`
